module.exports = __webpack_public_path__ + "static/media/steering-wheel.baa83af6.svg";